import type { RenderComponentProps } from "replo-runtime/shared/types";

import React from "react";

import { useProductTileContext } from "./ProductTileContext";

export const BundleProductVariantSelector: React.FC<RenderComponentProps> = ({
  component,
  componentAttributes,
}) => {
  const optionKey = component.props.optionKey as
    | "option1"
    | "option2"
    | "option3";
  const { getProductOptionByKey, selectOptionValue, selectedVariant } =
    useProductTileContext();
  const option = getProductOptionByKey(optionKey);
  if (!option?.values) {
    return null;
  }

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    selectOptionValue(optionKey, e.target.value);
  };

  return (
    <select
      {...componentAttributes}
      onChange={handleChange}
      value={selectedVariant?.[optionKey] ?? ""}
    >
      {option.values.map(({ available, title }) => {
        return (
          <option key={title} value={title} disabled={!available}>
            {title}
          </option>
        );
      })}
    </select>
  );
};
